import { useAuthStore } from '../store/authStore';
import { UserRole, ROLE_PERMISSIONS, Permission } from '../types/auth';

/**
 * Hook to check user permissions based on their role
 * 
 * Usage:
 *   const { canAcknowledgeAnomalies, canEditTags, isAdmin } = usePermissions();
 */
export function usePermissions() {
  const { user } = useAuthStore();

  const userRole = user?.roles?.[0] || UserRole.VIEWER;
  const permissions = ROLE_PERMISSIONS[userRole] || ROLE_PERMISSIONS[UserRole.VIEWER];

  return {
    // Direct permission checks
    canViewDashboard: permissions.viewDashboard,
    canViewCostExplorer: permissions.viewCostExplorer,
    canViewTagging: permissions.viewTagging,
    canViewAnomalies: permissions.viewAnomalies,
    canAcknowledgeAnomalies: permissions.acknowledgeAnomalies,
    canEditCostAllocationTags: permissions.editCostAllocationTags,
    canAccessAdmin: permissions.adminConsole,
    canManageUsers: permissions.manageUsers,

    // Role checks
    isAdmin: userRole === UserRole.ADMIN,
    isAnalyst: userRole === UserRole.ANALYST,
    isViewer: userRole === UserRole.VIEWER,

    // Generic permission checker
    hasPermission: (permission: Permission) => permissions[permission],

    // The user's primary role
    role: userRole,
  };
}
